import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, FormGroup, ValidationErrors } from "@angular/forms";
import { catchError, debounceTime, distinctUntilChanged, first, firstValueFrom, map, Observable, of, share, Subject, switchMap, take, tap } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MFKValidator implements AsyncValidator {
    private http = inject(HttpClient);
    private validatorInput: Subject<any>;

    validatorChain: Observable<any>;
    constructor() {
        this.validatorInput = new Subject();
        this.validatorChain = this.validatorInput.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap(value => this.http.get('https://apps.its.uiowa.edu/mfk/api-single.jsp?mfk=' + value, { responseType: 'text'})),
            map(resp => {
                if (!resp) return of(null);
                const parts = resp.split(/[\n\r]+/);
                return parts[0].trim() === '1' ? null : { 'MFK': parts[1].trim() };
            }),
            share(),
            take(1),
            catchError(_ => of(null)),
        );
    }
    validate(control: AbstractControl): Observable<ValidationErrors | null> {
        const override = control.parent?.get('allowInvalidMFK')?.value == true;
        if (override) return of(null);
        
        const raw = control.value as string ?? '';
        if (! raw) return of(null);

        const nocorp = raw.match(/^10\s+/) ? raw.substring(2).trim() : raw;
        const f = nocorp.split(/[\s-]+/).join('');
        setTimeout(() => this.validatorInput.next(f), 0);
        return this.validatorChain;
    }
}

